import React, { createContext, useContext } from "react";
import useTutorial from "./hooks/useTutorial";

const TutorialContext = createContext(null);

export const useTutorialContext = () => {
  const ctx = useContext(TutorialContext);
  if (!ctx) throw new Error("useTutorialContext must be used within TutorialProvider");
  return ctx;
};

const TutorialProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const tutorial = useTutorial();
  return <TutorialContext.Provider value={tutorial}>{children}</TutorialContext.Provider>;
};

export default TutorialProvider;
